import React from "react";

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost" | "danger" | "success";
  size?: "xs" | "sm" | "md" | "lg";
  shape?: "square" | "circle";
  children: React.ReactNode;
}

const sizeClasses = {
  xs: "text-xs",
  sm: "text-sm",
  md: "text-base",
  lg: "text-lg",
} as const;

// Equal padding on all sides ensures a square/circle shape
const iconInnerPadding = {
  xs: "p-0.5",
  sm: "p-1.5",
  md: "p-2",
  lg: "p-2.5",
} as const;

const shapeClasses = {
  square: "rounded-lg",
  circle: "rounded-full",
} as const;

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      variant = "ghost",
      size = "md",
      shape = "square",
      className = "",
      children,
      disabled,
      ...props
    },
    ref
  ) => {
    const effectiveVariant = variant === "success" ? "primary" : variant;

    return (
      <button
        type="button"
        className={`btn btn-${effectiveVariant} ${sizeClasses[size]} ${shapeClasses[shape]} ${className}`}
        ref={ref}
        disabled={disabled}
        {...props}
      >
        <span className={`btn-inner ${iconInnerPadding[size]}`}>{children}</span>
      </button>
    );
  }
);

IconButton.displayName = "IconButton";
